import { render, staticRenderFns } from "./PlaylistResources.vue?vue&type=template&id=62c3035c"
import script from "./PlaylistResources.vue?vue&type=script&lang=js"
export * from "./PlaylistResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports